// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"cd863c9a","277":"746915c2","527":"7e9efc21","799":"edfb30fd"}[chunkId] + ".chunk.js";
};